import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import { updateTemplateElementMultipleOptionsAction } from 'store/forms/actions';
import {
  selectPdfFormPageExtendedElements,
  selectPdfFormTemplateDependenceGroupsById,
} from 'store/forms/selectors';

export const useDeleteMultipleOptions = (args, selectedPage, setArgs) => {
  const dispatch = useDispatch();
  const pageElementsWithoutScaling = useSelector(
    selectPdfFormPageExtendedElements(selectedPage, 1),
  );
  const initialDependenceGroups = useSelector(selectPdfFormTemplateDependenceGroupsById);

  if (!args) {
    return;
  }

  const { rootDependenceGroupId, ...rest } = args;

  const updatedDependenceGroups = _.pickBy(
    initialDependenceGroups,
    item => item.rootDependenceGroupId !== rootDependenceGroupId,
  );

  delete updatedDependenceGroups[rootDependenceGroupId];

  const filteredElements = pageElementsWithoutScaling.filter(
    el =>
      (el.helloSignTag && !el.helloSignTag.rootDependenceGroupId) ||
      el.helloSignTag?.rootDependenceGroupId !== rootDependenceGroupId,
  );

  const actionBody = {
    ...rest,
    elements: filteredElements,
    dependenceGroups: Object.values(updatedDependenceGroups),
  };

  dispatch(updateTemplateElementMultipleOptionsAction(actionBody));
  setArgs(null);
};
